<!-- 车辆管理 -->
<template>
  <div class="energy w1400">
    <div class="table">
      <div class="container">
        <div class="handle-box">
          <el-input placeholder="请输入车牌号" v-model="search" @clear="getVehicle" clearable class="handle-input mr10"></el-input>
          <el-button type="primary" icon="search" @click="searchLine">搜索</el-button>
        </div>
        <el-table v-loading="loading" :data="vehicleData" border style="width: 100%" ref="multipleTable">
          <el-table-column prop="ta002" label="物流企业名称"  />
          <el-table-column prop="tb002" label="车牌号码"  />
          <el-table-column prop="tb004" label="环保类型" >
            <template slot-scope="scope">
              <el-tag :type="scope.row.tb004 == 1 ? 'danger' : 'success'">{{
                scope.row.tb004 == 1 ? "燃油车" : "新能源车"
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="tb005" label="动力类型"  :formatter="powerType">
          </el-table-column>
          <el-table-column prop="tb006" label="车型" :formatter="carType">
          </el-table-column>
          <el-table-column prop="tb024" label="箱型"  :formatter="boxTypes"></el-table-column>
          <el-table-column prop="tb028" label="是否是冷链车" >
            <template slot-scope="scope">
              {{scope.row.tb028==1?'是':'否'}}
            </template>
          </el-table-column>
          <el-table-column prop="tb019" label="联系电话"  />
          <el-table-column prop="tb020" label="联系姓名" />
<!--          <el-table-column prop="tb022" label="GPS备案号" width="120" />-->
        </el-table>
        <div class="page">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        currentPage:1,
        pageSize:10,
        vehicleData: [], //车辆信息
        companyData: [], //企业代号
        updateVehiclerow: 0,
        loading: true,
        search: "",
        //是否冷链车
        coldCar: [{
            value: '是',
            index: 1
          },
          {
            value: '否',
            index: 2
          }
        ],
        total:0,
      };
    },
    created() {
      this.getVehicle();
    },
    computed: {},
    methods: {
      //获取物流车辆代号
      async getVehicle() {
        const {
          data: res
        } = await this.$axios.post("/api/vehicle/list", {
          pageSize: this.pageSize,
          skip: (this.currentPage-1)*this.pageSize,
          where: "and isdelete=0",
        });
        if (res.code != 200)
          return this.$message({
            type: "error",
            message: "获取线路失败"
          });
        this.vehicleData = res.data;
        this.total = res.count;
        this.loading = false;
      },

      //搜索
      async searchLine() {
        const search = this.search;
        if (search.length == 0) return;
        const {
          data: res
        } = await this.$axios.post("/api/vehicle/list", {
          where: " and tb002='" + this.search + "'",
        });
        if (res.data.length == 0)
          return this.$message({
            type: "info",
            message: "没有该车"
          });
        this.vehicleData = res.data;
      },
      //获取物流企业代号
      async getMonpany() {
        if (this.companyData.length == 0) {
          const {
            data: res
          } = await this.$axios.post("/api/company/list", {
            skip: 0,
            where: "and isdelete=0",
          });
          if (res.code != 200)
            return this.$message({
              type: "error",
              message: "企业物流代号获取失败",
            });
          this.companyData = res.data;
        }
      },
      carType(row, column) {
        let type = '';
        switch (parseInt(row.tb006)) {
          case 1:
            type = "微型货车 (GA≤1．8吨)";
            break;
          case 2:
            type = "轻型货车 (1．8吨＜GA≤6吨)";
            break;
          case 3:
            type = "中形货车 (6吨＜GA≤14吨)";
            break;
          case 4:
            type = "重型货车 (GA>14吨)";
            break;
        }
        return type
      },
      powerType(row, column) {
        let type = ''
        switch (parseInt(row.tb005)) {
          case 1:
            type = "燃油货车";
            break;
          case 2:
            type = "纯电动货车";
            break;
          case 3:
            type = "插电式混合动力货车";
            break;
          case 4:
            type = "燃料电池货车";
            break;
          case 5:
            type = "清洁能源货车";
            break;
          case 6:
            type = "其他";
            break;
        }
        return type
      },
      boxTypes(row, column) {
        let type = ''
        switch (parseInt(row.tb024)) {
          case 1:
            type = "平板式";
            break;
          case 2:
            type = "栏板式1";
            break;
          case 3:
            type = "箱式";
            break;
          case 4:
            type = "封闭式";
            break;
        }
        return type
      },
      handleSizeChange(val){
        this.pageSize = val;
        this.getVehicle();
      },
      handleCurrentChange(val){
        this.currentPage = val;
        this.getVehicle();
      }
    },
  };
</script>

<style scoped>
  .energy{
    position: relative;
    padding-bottom: 10rem;
  }
  .handle-box {
    margin-bottom: 2rem;
    margin-top: 2rem;
  }

  .handle-select {
    width: 12rem;
  }

  .handle-input {
    width: 30rem;
    display: inline-block;
  }
  .page{
    position: absolute;
    bottom: 3.8rem;
    left: 50%;
    transform: translateX(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/components/page/energy.vue